// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table_wrapper__1kMh3","default":"Table_default__QmqQw"};